import type { PdpDeliveryAppVm } from '../../application/viewModels/pdpDelivery.app.vm';

export interface PdpDeliveryStoreItemVm {
  storeId: string;
  storeName: string;
  storeAddress: string;
  contactNumber: string;
  cityName: string;
}

export interface PdpDeliveryPresentationVm {
  hasDeliveryData: boolean;
  edd: string | null;
  eddFullDate: string | null;
  pincode: string | null;
  cityName: string | null;
  sameDayMessage: string | null;
  showStoreBox: boolean;
  storeName: string | null;
  nearbyStoreCount: number;
  isDirectContactAllowed: boolean;
  contactNumber: string | null;
  whatsappNumber: string | null;
  inventoryStores: PdpDeliveryStoreItemVm[];
  nearbyStoresList: PdpDeliveryStoreItemVm[];
  designEddDetails: unknown | null;
}

function toStoreItemVm(store: {
  storeId: string;
  storeName: string;
  storeAddress: string;
  contactNumber: string;
  cityName: string;
}): PdpDeliveryStoreItemVm {
  return {
    storeId: store.storeId,
    storeName: store.storeName,
    storeAddress: store.storeAddress,
    contactNumber: store.contactNumber,
    cityName: store.cityName,
  };
}

export function toPdpDeliveryPresentationVm(
  appVm: PdpDeliveryAppVm | null
): PdpDeliveryPresentationVm {
  if (!appVm) {
    return {
      hasDeliveryData: false,
      edd: null,
      eddFullDate: null,
      pincode: null,
      cityName: null,
      sameDayMessage: null,
      showStoreBox: false,
      storeName: null,
      nearbyStoreCount: 0,
      isDirectContactAllowed: false,
      contactNumber: null,
      whatsappNumber: null,
      inventoryStores: [],
      nearbyStoresList: [],
      designEddDetails: null,
    };
  }

  const showStoreBox =
    Boolean(appVm.storeName) ||
    appVm.nearbyStoreCount > 0 ||
    appVm.nearbyStoresList.length > 0;

  return {
    hasDeliveryData: Boolean(appVm.edd || appVm.pincode),
    edd: appVm.edd,
    eddFullDate: appVm.eddFullDate,
    pincode: appVm.pincode || null,
    cityName: appVm.cityName,
    sameDayMessage: appVm.sameDayMessage,
    showStoreBox,
    storeName: appVm.storeName,
    nearbyStoreCount: appVm.nearbyStoreCount,
    isDirectContactAllowed: appVm.isDirectContactAllowed,
    contactNumber: appVm.contactNumber,
    whatsappNumber: appVm.whatsappNumber,
    inventoryStores: appVm.inventoryStores.map(toStoreItemVm),
    nearbyStoresList: appVm.nearbyStoresList.map(toStoreItemVm),
    designEddDetails: appVm.designEddDetails,
  };
}

export function getSameDayDeliveryLabel(message: string | null): string | null {
  if (message === 'same-day-delivery') return 'same-day delivery';
  if (message === 'next-day-delivery') return 'next-day delivery';
  return null;
}
